import { Grid } from "@mui/material";
import { apiClient } from "api/apiClient";
import { useEffect, useRef, useState } from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import "swiper/swiper.min.css";
import InsightsBox from "./components/InsightsBox";

const InsightsComponent = ({ small, insightTitle }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [news, setNews] = useState([]);
  const [pageCount, setPageCount] = useState(1);

  const [active, setActive] = useState(1);
  const [year, setYear] = useState("2022");
  useEffect(() => {
    apiClient.getNews(active, year).then((res) => {
      setNews(res?.data.data?.sort((a, b) => b.publishedAt-a.publishedAt));
      setPageCount(res?.data?.meta?.pagination?.pageCount);
      console.log("News data",res?.data?.data);
    });

  }, [active, year]);

  return (
    <Grid
      container
      spacing={2}
      style={{
        width: "auto",
        background: "#1C1C1C",
        padding: small ? "23px 16px" : "24px 80px 80px 80px",
      }}
    >
      <Grid item xs={12} style={{ marginBottom: 42 }}>
        <Box
          margin="24px 0"
          textAlign="center"
          display="flex"
          flexDirection="column"
        >
          <Text
            textColor="white"
            fontWeight="bold"
            fontSize={small ? "24px" : "40px"}
            margin="16px 0"
          >
            {insightTitle?.attributes?.title}
          </Text>
          <Box w={small ? "100%" : "600px"} margin="0 auto">
            <Text
              textColor="white"
              fontSize={small ? "14px" : "17px"}
              margin="0"
            >
              {insightTitle?.attributes?.description}
            </Text>
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Swiper
          spaceBetween={small ? 10 : 20}
          slidesPerView={small ? 1 : 3}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          autoplay={{
            delay: 4500,
            disableOnInteraction: false,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
          }}
          modules={[Autoplay, Pagination, Navigation]}
          className="mySwiper"
        >
          {news.map((item) => (
            <SwiperSlide key={item.id} style={{ backgroundColor: "#1C1C1C", minHeight:364, maxHeight:364}}>
              <InsightsBox small={small} data={item.attributes} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Grid>
    </Grid>
  );
};

export default InsightsComponent;
